export const roles = {
  PlatformAdmin: "platform_admin",
  SiteAdmin: "site_admin",
  HubAdmin: "hub_admin",
  ProjectAdmin: "project_admin",
  Participant: "participant",
  BlockedUser: "blocked_user"
};
